import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';

/**
 * Returns true when a workflow transition should replace (not push) the history entry.
 *
 * Currently only the Deal Setup (INVALID) is a transient "gate" screen — the browser
 * Back or forward navigation should not return the user to it after the deal has been launched.
 */
export const shouldReplaceHistory = (prevStatus: WorkflowStatus | undefined): boolean => prevStatus === WorkflowStatus.INVALID;
